"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _listings = require("../../../../constants/listings");
var _analytics = require("../../../../constants/analytics");
var _listingModule = require("../../../listingModule");
var _AutoconflowConnectionSection = _interopRequireDefault(require("./AutoconflowConnectionSection"));
var _AdminListingConnectionSection = _interopRequireDefault(require("./AdminListingConnectionSection"));
var _UserListingConnectionSection = _interopRequireDefault(require("../UserListingConnectionSection"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Components

function CocpapListingConnectionSection(_ref) {
  var listing = _ref.listing,
    trackButtonClick = _ref.trackButtonClick,
    launchTermsAndConditionsModal = _ref.launchTermsAndConditionsModal,
    companyUUID = _ref.companyUUID,
    isTestEntity = _ref.isTestEntity,
    disconnectFromListing = _ref.disconnectFromListing,
    toggleModal = _ref.toggleModal,
    isConnecting = _ref.isConnecting,
    trackLinkClick = _ref.trackLinkClick,
    profile = _ref.profile,
    handleRequestInformationClick = _ref.handleRequestInformationClick,
    onConnect = _ref.onConnect,
    isDisabled = _ref.isDisabled;
  var ID = listing.ID,
    _listing$core = listing.core,
    flow = _listing$core.oAuthWorkflowType,
    listingName = _listing$core.listingName,
    v1ID = _listing$core.v1ID,
    clientOptInType = _listing$core.clientOptInType,
    hasCustomDisconnectUrl = listing.hasCustomDisconnectUrl;
  var buttonClickTrackingDimensions = {
    listingId: ID,
    listingName: listingName,
    companyUUID: companyUUID
  };
  function onDisconnect() {
    trackButtonClick({
      elementPath: ["".concat(_analytics.listingConst, " ").concat(listingName), _analytics.button.disconnect],
      dimensions: buttonClickTrackingDimensions
    });
    if (hasCustomDisconnectUrl) {
      disconnectFromListing(ID, v1ID);
    } else {
      toggleModal(_listingModule.DISCONNECT_MODAL);
    }
  }
  if (clientOptInType === _listings.OPT_IN_TYPES.USER && flow !== _listings.LISTING_CONNECTION_FLOWS.AUTOCONFLOW) {
    return /*#__PURE__*/_react.default.createElement(_UserListingConnectionSection.default, {
      listing: listing,
      isConnecting: isConnecting,
      onConnectClick: onConnect,
      isDisabled: isDisabled,
      onDisconnectClick: onDisconnect
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "loyalty-box",
    style: {
      textAlign: 'center'
    }
  }, clientOptInType === _listings.OPT_IN_TYPES.ADMIN && /*#__PURE__*/_react.default.createElement(_AdminListingConnectionSection.default, {
    listing: listing,
    profile: profile,
    onDisconnectButtonClick: onDisconnect,
    onConnectButtonClick: onConnect,
    onRequestInformationClick: handleRequestInformationClick,
    isConnecting: isConnecting,
    isTestEntity: isTestEntity
  }), flow === _listings.LISTING_CONNECTION_FLOWS.AUTOCONFLOW && /*#__PURE__*/_react.default.createElement(_AutoconflowConnectionSection.default, {
    listing: listing,
    onConnectButtonClick: onConnect,
    onDisconnectButtonClick: onDisconnect,
    isConnecting: isConnecting,
    trackLinkClick: trackLinkClick,
    trackButtonClick: trackButtonClick,
    launchTermsAndConditionsModal: launchTermsAndConditionsModal,
    isDisabled: isDisabled,
    companyUUID: companyUUID
  }));
}
CocpapListingConnectionSection.propTypes = {
  listing: _propTypes.default.shape({
    ID: _propTypes.default.string.isRequired,
    core: _propTypes.default.shape({
      oAuthWorkflowType: _propTypes.default.string.isRequired,
      listingName: _propTypes.default.string.isRequired,
      v1ID: _propTypes.default.string.isRequired,
      clientOptInType: _propTypes.default.string.isRequired
    }),
    hasCustomDisconnectUrl: _propTypes.default.bool
  }),
  trackButtonClick: _propTypes.default.func.isRequired,
  trackLinkClick: _propTypes.default.func.isRequired,
  launchTermsAndConditionsModal: _propTypes.default.func.isRequired,
  companyUUID: _propTypes.default.string.isRequired,
  disconnectFromListing: _propTypes.default.func.isRequired,
  toggleModal: _propTypes.default.func.isRequired,
  isConnecting: _propTypes.default.bool,
  profile: _propTypes.default.shape({
    Role: _propTypes.default.number
  }).isRequired,
  handleRequestInformationClick: _propTypes.default.func.isRequired,
  onConnect: _propTypes.default.func.isRequired,
  isDisabled: _propTypes.default.bool,
  isTestEntity: _propTypes.default.bool
};
var _default = exports.default = CocpapListingConnectionSection;